import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../../services/axios';
import actionTypes from '../actionTypes';
import {
  IBillboardsResponse,
  IBillboardsResponseState,
} from './billboards.model';

export const fetchBillboards = createAsyncThunk(
  actionTypes.FETCH_BILLBOARDS,
  async (): Promise<IBillboardsResponseState> => {
    try {
      const response = await axiosInstance.get<IBillboardsResponse[]>(
        '/v1/location/billboards'
      );

      return {
        response: response.data,
      };
    } catch (e) {
      console.error(JSON.stringify(e));
      // TODO: create right error message
      throw e;
    }
  }
);
